import { useEffect, useState } from 'react';

const STORAGE_KEY = 'desktopSidebarHidden';

export function useDesktopSidebarHidden() {
  const [isDesktopSidebarHidden, setIsDesktopSidebarHidden] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, isDesktopSidebarHidden ? 'true' : 'false');
    } catch {
      // Ignore storage failures (private mode / restricted storage).
    }
  }, [isDesktopSidebarHidden]);

  return {
    isDesktopSidebarHidden,
    setIsDesktopSidebarHidden,
  };
}

